const STORAGE_PREFIX = 'appliedSubstituicaoIds';

// Isolado por e-mail do usuário logado — sessionStorage não é limpo automaticamente
// entre trocas de conta na mesma aba, então sem esse escopo a marca "já se candidatou"
// de uma conta vazava para a próxima que logasse no mesmo navegador.
function storageKey(email: string): string {
  return `${STORAGE_PREFIX}:${email.toLowerCase()}`;
}

function readIds(email: string): Set<number> {
  try {
    const raw = sessionStorage.getItem(storageKey(email));
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as number[]);
  } catch {
    return new Set();
  }
}

function writeIds(email: string, ids: Set<number>) {
  sessionStorage.setItem(storageKey(email), JSON.stringify([...ids]));
}

export function markSubstituicaoAsApplied(email: string, id: number) {
  const ids = readIds(email);
  ids.add(id);
  writeIds(email, ids);
}

export function getAppliedSubstituicaoIds(email?: string | null): Set<number> {
  if (!email) return new Set();
  return readIds(email);
}

export function clearAppliedSubstituicaoIds(email: string) {
  sessionStorage.removeItem(storageKey(email));
}
